<template>
<w-app id="app">

  <z-sidebar />

  <w-flex column justify-center class="zcontainerx" >

    <z-header :crumbs="crumbs"/>


    <!-- <div class="header-bottom">
      <a href="" class="profile-name">{{ $page.props.auth.user.name }}</a> 
      <br><br>
      <w-button class="profile_user" outline md>{{$page.props.auth.user.display_roles.toString()}}</w-button>
    </div> -->

    <main class="grow" :class="bgColor">

      <div class="title2 ml3">
        {{ title }}
      </div>

     


      <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.success"
          success
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.success}}
        </w-alert>
        </w-transition-bounce>
        <w-transition-bounce>

        <w-alert
          class="my0 mb2 text-light"
          v-if="$page.props.flash.error"
          error
          transition="bounce"
          plain
          round
          no-border
          dismiss
          >
            {{$page.props.flash.error}}
        </w-alert>
      </w-transition-bounce>

      <w-notification
        v-if="$page.props.flash.notify"
        success
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notify = ''"
        >
        {{$page.props.flash.notify}}
      </w-notification>

      <w-notification
        v-if="$page.props.flash.notifyerror"
        error
        transition="bounce"
        absolute
        plain
        round
        timeout="2000"
        @close="$page.props.flash.notifyerror = ''"
        >
        {{$page.props.flash.notifyerror}}
      </w-notification>



      
      <slot />

    </main>

    <z-footer />

  </w-flex>
</w-app>
</template>

<script>

import zHeader from '@/Shared/Layout/Header'
import zSidebar from '@/Shared/Layout/Sidebar'
import zFooter from '@/Shared/Layout/Footer'

export default {
components: {
  zHeader,
  zSidebar,
  zFooter
},
props: {
  title: {
    type: String,
    default: 'Welcome to zTemplate'
  },
  showuserinfo: {
    type: Boolean,
    default: true
  },
  bgColor: {
    type: String,
    /* default: 'grey-light5--bg' */
    default: 'main--bg'
  },
  crumbs: {
    type: Array,
    default: [
        { label: 'AIMS', route: '/' }
      ],
  }
},
data: () => ({
}),
methods: {

},
mounted() {
  // alert(document.referrer);
  // if(this.$page.props.flash.success){
  //   alert(this.$page.props.flash.success);
  // }
    
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.l == 1){
      window.location.replace(window.location.pathname);
    }
}
}

</script>

<style>

.w-app {
  padding: 0px;
  flex-direction: row;
}

aside, main {
  margin: 0px;
  padding: 12px;
}

header  {
  position: inherit !important;
  background-color: #5979be !important;
  color:white;
  background: rgb(51, 47, 127);
  background: linear-gradient(270deg, rgba(51, 47, 127, 1) 0%, rgba(63, 58, 150, 1) 100%);
  z-index: 1;
}

.menu-active {
  background-color: #bbbaba !important;
}

.zcontainer {
  margin-top: 55px;
}

.welcomeuserinfo {
  border-radius: 3px;
}

.welcomeuserinfo:before {
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.1;
  /* background-image: url('/images/zen.jpeg'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.box h4 {
    font-weight: 500;
    font-size: 20px;
}
.grow .title2 {
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: .5px;
}
.profile-welcome {
    font-weight: bold;
    margin-top: 4px;
    margin-bottom: 2px;
}
.profile-role {
    padding-top: 8px;
}
.profile-role-name{
    font-weight: bold;
    text-transform: uppercase;
    color: blue;
}
.profile_user{
   color: #731212 !important;
}
.menu-active {
    background-color: #383388 !important;
    color: #fff !important;
}
.menu-active.menu-is-child {
    color: #fff !important;
}
.primary-dark1--bg {
    background-color: #001f59;
    background: linear-gradient(270deg, #332f7f, #3f3a96);
    font-size: 15px;
    padding: 15px;
}
.w-app .size--md {
    font-size: 11px;
}
.zsidebar .size--md {
    font-size: 13px !important;
}
.w-card {
    z-index: 3;
}
</style>
